<template>
  <div class="photos-page">
    <iframe
      src="https://albumizr.com/a/0kyx"
      scrolling="yes"
      frameborder="0"
      allowfullscreen
      width="100%"
      height="400"
    ></iframe>
  </div>
</template>

<script>
export default {};
</script>

<style>
.photos-page {
  position: relative;
  z-index: 2;
  padding: 12vh 5vw;
}
</style>